// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"72":"Cart","80":"Orders","301":"OneFoodPage","672":"Admin","888":"Auth"}[chunkId] + "." + {"72":"54ebfd9c","80":"718de87d","301":"6137a693","672":"a5afb2bf","888":"19f84316"}[chunkId] + ".chunk.css";
};